import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const { currentUser, approved, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center p-6 text-center">
                <div>
                    <p className="text-lg font-semibold">{t("loading", "Loading...")}</p>
                    <p className="text-sm text-gray-500">
                        {t("privateRoute.checkingPermissions", "Checking your access permissions.")}
                    </p>
                </div>
            </div>
        );
    }

    if (!currentUser) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (!approved) {
        return (
            <div className="min-h-screen flex items-center justify-center p-6 text-center bg-slate-50">
                <div className="max-w-md rounded-2xl border bg-white p-6 shadow-sm">
                    <h1 className="text-2xl font-bold mb-2">
                        {t("privateRoute.accessPending", "Access pending")}
                    </h1>
                    <p className="text-gray-600">
                        {t(
                            "privateRoute.accessPendingDesc",
                            "Your account was created, but it still needs approval before you can access BuzHere."
                        )}
                    </p>
                </div>
            </div>
        );
    }

    return children;
};

export default PrivateRoute;